import React from 'react'

import Select, { GroupBase, Props, StylesConfig } from 'react-select'

import { getColor } from '@/key-components/utils/KeyColors'

const customStyles: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
  container: (styles) => {
    return {
      ...styles,
      minWidth: 120,
      maxWidth: 480,
    }
  },
  control: (base, { isFocused }) => ({
    alignItems: 'center',
    background: 'white',
    borderColor: isFocused ? getColor('z', '9') : getColor('grey', 'l2'),
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 1,
    display: 'flex',
    flexWrap: 'wrap',
    fontFamily: 'Inter, sans-serif',
    justifyContent: 'space-between',
    minHeight: 32,
    position: 'relative',
    transition: 'all 100ms',
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: '2px 4px',
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: '0 8px',
  }),
  placeholder: (styles) => ({
    ...styles,
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    color: getColor('grey', 'd1'),
    textWrap: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  menu: (styles) => ({
    ...styles,
  }),
  option: (styles) => {
    return {
      ...styles,
      fontFamily: 'Inter, sans-serif',
      fontSize: 12,
      color: getColor('grey', 'd1'),
      background: 'white',
      '&:active': {
        background: getColor('grey', 'l4'),
      },
      '&:hover': {
        background: getColor('grey', 'l4'),
      },
    }
  },
  input: (styles) => {
    return {
      ...styles,
      fontFamily: 'Inter, sans-serif',
      fontSize: 14,
      color: getColor('grey', 'd1'),
      '&:focus': {
        background: 'red',
      },
    }
  },
  singleValue: (styles) => {
    return {
      ...styles,
      fontFamily: 'Inter, sans-serif',
      fontSize: 14,
      color: getColor('grey', 'd1'),
    }
  },
  indicatorSeparator: () => null,
  groupHeading: (styles) => {
    return {
      ...styles,
      textTransform: 'initial',
      fontFamily: 'Inter, sans-serif',
      fontSize: 14,
      fontWeight: 'bold',
      color: getColor('grey', 'd1'),
    }
  },
}

/**
 * @deprecated key-* components are no longer supported.
 */
export function KeySelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group>) {
  return (
    <Select
      {...props}
      openMenuOnFocus={true}
      styles={{ ...customStyles, ...props.styles }}
    />
  )
}
